import { Deserializable } from '../protocols/deserializable';

export class OutboundPaymentChangeDate implements Deserializable {
  public cutOffDate!: string;
  public allowableChangeDate!: string;

  public onDeserialize(): void {}
}
